import React, { useEffect, useState } from "react";
import { Input } from "antd";

const DebounceInput = props => {
  const { onChange, timeout, value, label } = props;
  const [val, setVal] = useState(undefined);

  useEffect(() => {
    setVal(value);
  }, [value]);

  const [timer,setTimer] = useState(null);
  const createSearchTimer = (e) => {
    if (timer !== null)
      clearTimeout(timer);
    setTimer(setTimeout(() => {
      if (onChange) {
        onChange(e.target.value);
      }
    }, timeout || 500));
  };

  const onChangeVal = event => {
    setVal(event.target.value);
    event.persist();
    createSearchTimer(event);
  };

  return <Input {...props} value={val} onChange={onChangeVal} label={label} />;
};

export default DebounceInput;
